/**
 * §6.11 Ideal Success Scenarios — 5 target-audience personas.
 */

import React from 'react'
import {
  GraduationCap, Briefcase, Users, Rocket, Building2, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { SCENARIOS } from '../data'
import { TONE } from '../_shared'

const ICONS = { GraduationCap, Briefcase, Users, Rocket, Building2 }

export default function Scenarios() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Ideal Success Scenarios</Eyebrow>
          <SectionHeading align="center"
            title={<>Five profiles.{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">One platform.</span></>}
            subtitle="White-label is a fit whenever you have a customer base you'd like to serve with a differentiated, recurring-revenue product. These five are where Kalki Ai Cloud shines brightest."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {SCENARIOS.map((s) => {
            const tone = TONE[s.tone] || TONE.orange
            const Icon = ICONS[s.iconKey] || Sparkles
            return (
              <div key={s.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 19, height: 19 }} />
                  </span>
                  <div>
                    <h4 className="text-[14.5px] font-semibold text-white leading-tight">{s.label}</h4>
                    <p className="text-[12.5px] text-zinc-400 leading-relaxed mt-1.5">{s.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
